// source: EntrustVoPb.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf')
var goog = jspb
var global = Function('return this')()

goog.exportSymbol('proto.EntrustVoPb', null, global)
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.EntrustVoPb = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null)
}
goog.inherits(proto.EntrustVoPb, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.EntrustVoPb.displayName = 'proto.EntrustVoPb'
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.EntrustVoPb.prototype.toObject = function (opt_includeInstance) {
    return proto.EntrustVoPb.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.EntrustVoPb} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.EntrustVoPb.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        id: jspb.Message.getFieldWithDefault(msg, 1, 0),
        tradeid: jspb.Message.getFieldWithDefault(msg, 2, 0),
        entrusttime: jspb.Message.getFieldWithDefault(msg, 3, 0),
        buycoinshortname: jspb.Message.getFieldWithDefault(msg, 4, ''),
        sellcoinshortname: jspb.Message.getFieldWithDefault(msg, 5, ''),
        type: jspb.Message.getFieldWithDefault(msg, 6, 0),
        direction: jspb.Message.getFieldWithDefault(msg, 7, 0),
        matchtype: jspb.Message.getFieldWithDefault(msg, 8, 0),
        pricetype: jspb.Message.getFieldWithDefault(msg, 9, ''),
        entrustprice: jspb.Message.getFieldWithDefault(msg, 10, ''),
        count: jspb.Message.getFieldWithDefault(msg, 11, ''),
        successcount: jspb.Message.getFieldWithDefault(msg, 12, ''),
        averageprice: jspb.Message.getFieldWithDefault(msg, 13, ''),
        status: jspb.Message.getFieldWithDefault(msg, 14, 0),
        history: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
        pushversion: jspb.Message.getFieldWithDefault(msg, 16, 0),
        remove: jspb.Message.getBooleanFieldWithDefault(msg, 17, false),
        amount: jspb.Message.getFieldWithDefault(msg, 18, ''),
        marketunit: jspb.Message.getFieldWithDefault(msg, 19, ''),
        funds: jspb.Message.getFieldWithDefault(msg, 20, ''),
        leftfunds: jspb.Message.getFieldWithDefault(msg, 21, ''),
        triggerprice: jspb.Message.getFieldWithDefault(msg, 22, ''),
        marginmode: jspb.Message.getFieldWithDefault(msg, 23, ''),
        margintrademode: jspb.Message.getFieldWithDefault(msg, 24, ''),
        forcedliquidation: jspb.Message.getBooleanFieldWithDefault(msg, 25, false),
        remark: jspb.Message.getFieldWithDefault(msg, 26, ''),
        successamount: jspb.Message.getFieldWithDefault(msg, 27, ''),
        tradearea: jspb.Message.getFieldWithDefault(msg, 28, 0),
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EntrustVoPb}
 */
proto.EntrustVoPb.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.EntrustVoPb()
  return proto.EntrustVoPb.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EntrustVoPb} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EntrustVoPb}
 */
proto.EntrustVoPb.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setId(value)
        break
      case 2:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setTradeid(value)
        break
      case 3:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setEntrusttime(value)
        break
      case 4:
        var value = /** @type {string} */ (reader.readString())
        msg.setBuycoinshortname(value)
        break
      case 5:
        var value = /** @type {string} */ (reader.readString())
        msg.setSellcoinshortname(value)
        break
      case 6:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setType(value)
        break
      case 7:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setDirection(value)
        break
      case 8:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setMatchtype(value)
        break
      case 9:
        var value = /** @type {string} */ (reader.readString())
        msg.setPricetype(value)
        break
      case 10:
        var value = /** @type {string} */ (reader.readString())
        msg.setEntrustprice(value)
        break
      case 11:
        var value = /** @type {string} */ (reader.readString())
        msg.setCount(value)
        break
      case 12:
        var value = /** @type {string} */ (reader.readString())
        msg.setSuccesscount(value)
        break
      case 13:
        var value = /** @type {string} */ (reader.readString())
        msg.setAverageprice(value)
        break
      case 14:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setStatus(value)
        break
      case 15:
        var value = /** @type {boolean} */ (reader.readBool())
        msg.setHistory(value)
        break
      case 16:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setPushversion(value)
        break
      case 17:
        var value = /** @type {boolean} */ (reader.readBool())
        msg.setRemove(value)
        break
      case 18:
        var value = /** @type {string} */ (reader.readString())
        msg.setAmount(value)
        break
      case 19:
        var value = /** @type {string} */ (reader.readString())
        msg.setMarketunit(value)
        break
      case 20:
        var value = /** @type {string} */ (reader.readString())
        msg.setFunds(value)
        break
      case 21:
        var value = /** @type {string} */ (reader.readString())
        msg.setLeftfunds(value)
        break
      case 22:
        var value = /** @type {string} */ (reader.readString())
        msg.setTriggerprice(value)
        break
      case 23:
        var value = /** @type {string} */ (reader.readString())
        msg.setMarginmode(value)
        break
      case 24:
        var value = /** @type {string} */ (reader.readString())
        msg.setMargintrademode(value)
        break
      case 25:
        var value = /** @type {boolean} */ (reader.readBool())
        msg.setForcedliquidation(value)
        break
      case 26:
        var value = /** @type {string} */ (reader.readString())
        msg.setRemark(value)
        break
      case 27:
        var value = /** @type {string} */ (reader.readString())
        msg.setSuccessamount(value)
        break
      case 28:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setTradearea(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.EntrustVoPb.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.EntrustVoPb.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EntrustVoPb} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.EntrustVoPb.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = message.getId()
  if (f !== 0) {
    writer.writeInt64(1, f)
  }
  f = message.getTradeid()
  if (f !== 0) {
    writer.writeInt32(2, f)
  }
  f = message.getEntrusttime()
  if (f !== 0) {
    writer.writeInt64(3, f)
  }
  f = message.getBuycoinshortname()
  if (f.length > 0) {
    writer.writeString(4, f)
  }
  f = message.getSellcoinshortname()
  if (f.length > 0) {
    writer.writeString(5, f)
  }
  f = message.getType()
  if (f !== 0) {
    writer.writeInt32(6, f)
  }
  f = message.getDirection()
  if (f !== 0) {
    writer.writeInt32(7, f)
  }
  f = message.getMatchtype()
  if (f !== 0) {
    writer.writeInt32(8, f)
  }
  f = message.getPricetype()
  if (f.length > 0) {
    writer.writeString(9, f)
  }
  f = message.getEntrustprice()
  if (f.length > 0) {
    writer.writeString(10, f)
  }
  f = message.getCount()
  if (f.length > 0) {
    writer.writeString(11, f)
  }
  f = message.getSuccesscount()
  if (f.length > 0) {
    writer.writeString(12, f)
  }
  f = message.getAverageprice()
  if (f.length > 0) {
    writer.writeString(13, f)
  }
  f = message.getStatus()
  if (f !== 0) {
    writer.writeInt32(14, f)
  }
  f = message.getHistory()
  if (f) {
    writer.writeBool(15, f)
  }
  f = message.getPushversion()
  if (f !== 0) {
    writer.writeInt64(16, f)
  }
  f = message.getRemove()
  if (f) {
    writer.writeBool(17, f)
  }
  f = message.getAmount()
  if (f.length > 0) {
    writer.writeString(18, f)
  }
  f = message.getMarketunit()
  if (f.length > 0) {
    writer.writeString(19, f)
  }
  f = message.getFunds()
  if (f.length > 0) {
    writer.writeString(20, f)
  }
  f = message.getLeftfunds()
  if (f.length > 0) {
    writer.writeString(21, f)
  }
  f = message.getTriggerprice()
  if (f.length > 0) {
    writer.writeString(22, f)
  }
  f = message.getMarginmode()
  if (f.length > 0) {
    writer.writeString(23, f)
  }
  f = message.getMargintrademode()
  if (f.length > 0) {
    writer.writeString(24, f)
  }
  f = message.getForcedliquidation()
  if (f) {
    writer.writeBool(25, f)
  }
  f = message.getRemark()
  if (f.length > 0) {
    writer.writeString(26, f)
  }
  f = message.getSuccessamount()
  if (f.length > 0) {
    writer.writeString(27, f)
  }
  f = message.getTradearea()
  if (f !== 0) {
    writer.writeInt32(28, f)
  }
}

/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.EntrustVoPb.prototype.getId = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0))
}

/**
 * @param {number} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setId = function (value) {
  return jspb.Message.setProto3IntField(this, 1, value)
}

/**
 * optional int32 tradeId = 2;
 * @return {number}
 */
proto.EntrustVoPb.prototype.getTradeid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0))
}

/**
 * @param {number} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setTradeid = function (value) {
  return jspb.Message.setProto3IntField(this, 2, value)
}

/**
 * optional int64 entrustTime = 3;
 * @return {number}
 */
proto.EntrustVoPb.prototype.getEntrusttime = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0))
}

/**
 * @param {number} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setEntrusttime = function (value) {
  return jspb.Message.setProto3IntField(this, 3, value)
}

/**
 * optional string buyCoinShortName = 4;
 * @return {string}
 */
proto.EntrustVoPb.prototype.getBuycoinshortname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''))
}

/**
 * @param {string} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setBuycoinshortname = function (value) {
  return jspb.Message.setProto3StringField(this, 4, value)
}

/**
 * optional string sellCoinShortName = 5;
 * @return {string}
 */
proto.EntrustVoPb.prototype.getSellcoinshortname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''))
}

/**
 * @param {string} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setSellcoinshortname = function (value) {
  return jspb.Message.setProto3StringField(this, 5, value)
}

/**
 * optional int32 type = 6;
 * @return {number}
 */
proto.EntrustVoPb.prototype.getType = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0))
}

/**
 * @param {number} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setType = function (value) {
  return jspb.Message.setProto3IntField(this, 6, value)
}

/**
 * optional int32 direction = 7;
 * @return {number}
 */
proto.EntrustVoPb.prototype.getDirection = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0))
}

/**
 * @param {number} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setDirection = function (value) {
  return jspb.Message.setProto3IntField(this, 7, value)
}

/**
 * optional int32 matchType = 8;
 * @return {number}
 */
proto.EntrustVoPb.prototype.getMatchtype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0))
}

/**
 * @param {number} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setMatchtype = function (value) {
  return jspb.Message.setProto3IntField(this, 8, value)
}

/**
 * optional string priceType = 9;
 * @return {string}
 */
proto.EntrustVoPb.prototype.getPricetype = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''))
}

/**
 * @param {string} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setPricetype = function (value) {
  return jspb.Message.setProto3StringField(this, 9, value)
}

/**
 * optional string entrustPrice = 10;
 * @return {string}
 */
proto.EntrustVoPb.prototype.getEntrustprice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ''))
}

/**
 * @param {string} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setEntrustprice = function (value) {
  return jspb.Message.setProto3StringField(this, 10, value)
}

/**
 * optional string count = 11;
 * @return {string}
 */
proto.EntrustVoPb.prototype.getCount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ''))
}

/**
 * @param {string} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setCount = function (value) {
  return jspb.Message.setProto3StringField(this, 11, value)
}

/**
 * optional string successCount = 12;
 * @return {string}
 */
proto.EntrustVoPb.prototype.getSuccesscount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''))
}

/**
 * @param {string} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setSuccesscount = function (value) {
  return jspb.Message.setProto3StringField(this, 12, value)
}

/**
 * optional string averagePrice = 13;
 * @return {string}
 */
proto.EntrustVoPb.prototype.getAverageprice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ''))
}

/**
 * @param {string} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setAverageprice = function (value) {
  return jspb.Message.setProto3StringField(this, 13, value)
}

/**
 * optional int32 status = 14;
 * @return {number}
 */
proto.EntrustVoPb.prototype.getStatus = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0))
}

/**
 * @param {number} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setStatus = function (value) {
  return jspb.Message.setProto3IntField(this, 14, value)
}

/**
 * optional bool history = 15;
 * @return {boolean}
 */
proto.EntrustVoPb.prototype.getHistory = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false))
}

/**
 * @param {boolean} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setHistory = function (value) {
  return jspb.Message.setProto3BooleanField(this, 15, value)
}

/**
 * optional int64 pushVersion = 16;
 * @return {number}
 */
proto.EntrustVoPb.prototype.getPushversion = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0))
}

/**
 * @param {number} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setPushversion = function (value) {
  return jspb.Message.setProto3IntField(this, 16, value)
}

/**
 * optional bool remove = 17;
 * @return {boolean}
 */
proto.EntrustVoPb.prototype.getRemove = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false))
}

/**
 * @param {boolean} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setRemove = function (value) {
  return jspb.Message.setProto3BooleanField(this, 17, value)
}

/**
 * optional string amount = 18;
 * @return {string}
 */
proto.EntrustVoPb.prototype.getAmount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ''))
}

/**
 * @param {string} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setAmount = function (value) {
  return jspb.Message.setProto3StringField(this, 18, value)
}

/**
 * optional string marketUnit = 19;
 * @return {string}
 */
proto.EntrustVoPb.prototype.getMarketunit = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ''))
}

/**
 * @param {string} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setMarketunit = function (value) {
  return jspb.Message.setProto3StringField(this, 19, value)
}

/**
 * optional string funds = 20;
 * @return {string}
 */
proto.EntrustVoPb.prototype.getFunds = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ''))
}

/**
 * @param {string} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setFunds = function (value) {
  return jspb.Message.setProto3StringField(this, 20, value)
}

/**
 * optional string leftfunds = 21;
 * @return {string}
 */
proto.EntrustVoPb.prototype.getLeftfunds = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ''))
}

/**
 * @param {string} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setLeftfunds = function (value) {
  return jspb.Message.setProto3StringField(this, 21, value)
}

/**
 * optional string triggerPrice = 22;
 * @return {string}
 */
proto.EntrustVoPb.prototype.getTriggerprice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ''))
}

/**
 * @param {string} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setTriggerprice = function (value) {
  return jspb.Message.setProto3StringField(this, 22, value)
}

/**
 * optional string marginMode = 23;
 * @return {string}
 */
proto.EntrustVoPb.prototype.getMarginmode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ''))
}

/**
 * @param {string} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setMarginmode = function (value) {
  return jspb.Message.setProto3StringField(this, 23, value)
}

/**
 * optional string marginTradeMode = 24;
 * @return {string}
 */
proto.EntrustVoPb.prototype.getMargintrademode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ''))
}

/**
 * @param {string} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setMargintrademode = function (value) {
  return jspb.Message.setProto3StringField(this, 24, value)
}

/**
 * optional bool forcedLiquidation = 25;
 * @return {boolean}
 */
proto.EntrustVoPb.prototype.getForcedliquidation = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 25, false))
}

/**
 * @param {boolean} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setForcedliquidation = function (value) {
  return jspb.Message.setProto3BooleanField(this, 25, value)
}

/**
 * optional string remark = 26;
 * @return {string}
 */
proto.EntrustVoPb.prototype.getRemark = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ''))
}

/**
 * @param {string} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setRemark = function (value) {
  return jspb.Message.setProto3StringField(this, 26, value)
}

/**
 * optional string successAmount = 27;
 * @return {string}
 */
proto.EntrustVoPb.prototype.getSuccessamount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ''))
}

/**
 * @param {string} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setSuccessamount = function (value) {
  return jspb.Message.setProto3StringField(this, 27, value)
}

/**
 * optional int32 tradeArea = 28;
 * @return {number}
 */
proto.EntrustVoPb.prototype.getTradearea = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 28, 0))
}

/**
 * @param {number} value
 * @return {!proto.EntrustVoPb} returns this
 */
proto.EntrustVoPb.prototype.setTradearea = function (value) {
  return jspb.Message.setProto3IntField(this, 28, value)
}

goog.object.extend(exports, proto)
